import * as yup from "yup";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DateRange } from "react-date-range";
import { getAccountStatuses } from "../../../services/accountService";
import ReactSelect from "../../../components/common/ReactSelect";
import moment from "moment";
import _ from "lodash";

const schema = yup.object({
  statuses: yup.array(
    yup.object().shape({ label: yup.string(), value: yup.string() })
  ),
});

const AccountsFilterForm = ({ onFilter }) => {
  const [statuses, setStatuses] = useState([]);

  const [period, setPeriod] = useState([
    {
      startDate: null,
      endDate: new Date(""),
      key: "selection",
    },
  ]);

  useEffect(() => {
    const fetchStatuses = () => {
      const data = getAccountStatuses();
      setStatuses(data);
    };

    fetchStatuses();
  }, []);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    let start_date = "";
    let end_date = "";
    let account_statuses = "";

    if (period[0].startDate !== null) {
      start_date = moment(period[0].startDate).format("MM-DD-yyyy");
      end_date = moment(period[0].endDate).format("MM-DD-yyyy");
    }

    if (typeof data.statuses !== "undefined")
      if (!_.isEmpty(data.statuses))
        account_statuses = data.statuses.map((item) => item.label);

    onFilter(account_statuses, start_date, end_date);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8">
      <div className="grid grid-2 gap-6">
        <div className="col-span-2">
          <ReactSelect
            id="statuses-dropdown"
            name="statuses"
            title="Statuses"
            options={statuses}
            control={control}
            register={register("statuses")}
            errors={errors}
            multiple
          />
        </div>
      </div>
      <div className="grid grid-2 gap-6 mt-5">
        <div className="col-span-2">
          <label className="form-label">Date Registered</label>
          <DateRange
            startDatePlaceholder="Start Date"
            endDatePlaceholder="End Date"
            editableDateInputs={false}
            moveRangeOnFirstSelection={false}
            onChange={(item) => setPeriod([item.selection])}
            ranges={period}
          />
        </div>
      </div>
      <div className="grid grid-2 gap-6 mt-12">
        <div className="col-span-2">
          <button type="submit" className="button button-primary">
            Apply Filter
          </button>
        </div>
      </div>
    </form>
  );
};

export default AccountsFilterForm;
